<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">Operadores</h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">Gerencie acessos, acompanhe o status dos operadores e acesse as configurações relacionadas.</p>
        </div>
      </div>

      <div class="grid max-w-3xl grid-cols-1 gap-4 md:grid-cols-2" v-if="$store.state.user.admin">
        <div @click="irParaMensagensProibidas" class="card-access group cursor-pointer rounded-2xl border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
          <div class="flex items-center justify-center gap-2 rounded-t-2xl bg-gray-100 px-3 py-3">
            <svg class="h-4 w-4 text-blue-600 transition-all duration-300 group-hover:scale-110 group-hover:text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M7 4h10l4 4v10a2 2 0 01-2 2H5a2 2 0 01-2-2V8l4-4z" />
            </svg>
            <p class="text-sm font-medium text-gray-800">Mensagens Proibidas</p>
          </div>

          <div class="px-3 py-3">
            <div class="flex items-center justify-center gap-1 text-sm font-medium text-gray-700 transition group-hover:text-blue-600">
              Acessar
              <svg class="card-access-arrow h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 17L17 7M8 7h9v9" />
              </svg>
            </div>
          </div>
        </div>

        <div @click="irParaNumerosProibidos" class="card-access group cursor-pointer rounded-2xl border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
          <div class="flex items-center justify-center gap-2 rounded-t-2xl bg-gray-100 px-3 py-3">
            <svg class="h-4 w-4 text-blue-600 transition-all duration-300 group-hover:scale-110 group-hover:text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-12.728 12.728m0-12.728l12.728 12.728" />
            </svg>
            <p class="text-sm font-medium text-gray-800">Números Proibidos</p>
          </div>

          <div class="px-3 py-3">
            <div class="flex items-center justify-center gap-1 text-sm font-medium text-gray-700 transition group-hover:text-blue-600">
              Acessar
              <svg class="card-access-arrow h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 17L17 7M8 7h9v9" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div class="rounded-2xl border border-gray-200 bg-white p-6">
        <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
          <div class="flex flex-col gap-1">
            <label class="text-sm font-medium text-gray-500">Nome ou email</label>
            <input
              v-model="filtroBusca"
              type="text"
              placeholder="Nome ou email"
              class="h-11 w-full rounded-xl border border-gray-200 bg-white px-4 text-gray-700 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
            />
          </div>

          <div class="flex flex-col gap-1">
            <label class="text-sm font-medium text-gray-500">Status</label>
            <div class="relative group">
              <select
                id="status-select"
                v-model="filtroStatus"
                class="w-full h-11 px-4 pr-10 border border-gray-200 rounded-xl bg-white bg-none text-gray-700 shadow-sm appearance-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100 cursor-pointer"
              >
                <option value="">Todos</option>
                <option value="online">Online</option>
                <option value="offline">Offline</option>
              </select>
              <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>

          <div class="flex flex-col gap-1" v-if="$store.state.user.admin">
            <label class="text-sm font-medium text-gray-500">Centro de custo</label>
            <div class="relative group">
              <select
                id="centrocusto"
                v-model="filtroCentro"
                class="w-full h-11 px-4 pr-10 border border-gray-200 rounded-xl bg-white bg-none text-gray-700 shadow-sm appearance-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100 cursor-pointer"
              >
                <option value="">Todos</option>
                <option v-for="c in centroscustos" :key="c._id" :value="c._id">{{ c.nome }}</option>
              </select>
              <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>

          <div class="flex flex-col gap-1" v-if="$store.state.user.admin">
            <label class="text-sm font-medium text-gray-500">Listagem</label>
            <div class="flex min-h-11 items-center gap-2">
              <button
                type="button"
                @click="selecionarListagem(false)"
                :style="!listarDesativados ? getPrimaryButtonStyle() : { backgroundColor: '#ffffff', color: '#374151' }"
                class="h-9 rounded-lg border px-4 text-sm font-medium transition"
              >
                Ativos
              </button>
              <button
                type="button"
                @click="selecionarListagem(true)"
                :style="listarDesativados ? { backgroundColor: mixPrimaryColor('#b91c1c', 0.45), color: '#ffffff' } : { backgroundColor: '#ffffff', color: '#374151' }"
                class="h-9 rounded-lg border px-4 text-sm font-medium transition"
              >
                Desativados
              </button>
            </div>
          </div>

          <div class="flex flex-col items-stretch gap-2 md:col-span-4 sm:flex-row lg:col-span-1">
            <button @click="aplicarFiltros" type="button" class="h-11 w-full rounded-xl bg-blue-500 font-medium text-white transition hover:bg-blue-600">Buscar</button>

            <button @click="limparFiltros" type="button" class="h-11 rounded-xl border border-gray-200 bg-white px-4 font-medium text-gray-700 transition hover:bg-gray-50">Limpar</button>
          </div>
        </div>
      </div>

      <div class="mb-6 flex justify-end" v-if="$store.state.user.admin">
        <div class="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
          <button
            type="button"
            @click="baixarRelatorio"
            :disabled="baixandoRelatorio"
            class="flex w-full items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 py-3 text-sm font-medium text-gray-700 shadow-sm transition hover:shadow-md disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto"
          >
            <svg class="h-5 w-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14a2 2 0 002-2v-3M3 16v3a2 2 0 002 2" />
            </svg>
            <span>{{ baixandoRelatorio ? "Gerando relatório..." : "Baixar relatório" }}</span>
          </button>

          <router-link :to="`/${route}/form`" class="flex w-full items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 py-3 shadow-sm transition hover:shadow-md sm:w-auto">
            <heroicon name="plus-circle" class="h-6 w-6 text-green-600" />
            <span class="text-sm font-medium text-gray-700">Novo Operador</span>
          </router-link>
        </div>
      </div>

      <div class="w-full overflow-hidden sm:rounded-lg border border-gray-200 bg-white shadow-sm">
        <div class="overflow-x-auto">
          <table class="w-full min-w-max text-sm">
            <thead class="border-b bg-gray-100 tracking-wider text-gray-600">
              <tr>
                <th class="px-6 py-4 text-left font-medium">Operador</th>
                <th class="px-6 py-4 text-left font-medium">Email</th>
                <th class="px-6 py-4 text-left font-medium">Centro</th>
                <th class="px-6 py-4 text-center font-medium">Admin</th>
                <th class="px-6 py-4 text-center font-medium">Status</th>
                <th class="px-6 py-4 text-center font-medium">Ações</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="item in operadoresPaginados" :key="item._id" class="border-b border-gray-100 transition hover:bg-slate-50">
                <td class="px-6 py-5">
                  <div class="flex items-center gap-4">
                    <div class="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-50 text-sm font-semibold text-blue-700">
                      {{ getInitials(item.nome) }}
                    </div>
                    <div class="flex flex-col">
                      <span class="font-medium text-gray-800">{{ item.nome }}</span>
                      <span class="text-xs text-gray-400">Operador cadastrado</span>
                    </div>
                  </div>
                </td>

                <td class="px-6 text-gray-700">{{ item.email || "" }}</td>

                <td class="px-6 font-medium text-gray-700">
                  {{ item.centrocusto && item.centrocusto.nome ? item.centrocusto.nome : "-" }}
                </td>

                <td class="px-6 text-center">
                  <span :class="item.admin ? 'rounded-full bg-blue-100 px-3 py-1 text-xs text-blue-700' : 'rounded-full bg-gray-100 px-3 py-1 text-xs text-gray-600'">
                    {{ item.supervisor ? "Supervisor" : item.admin ? "Sim" : "Não" }}
                  </span>
                </td>

                <td class="px-6 text-center">
                  <span v-if="!item.ativo" class="rounded-full bg-gray-200 px-3 py-1 text-xs text-gray-700">Desativado</span>
                  <span
                    v-else
                    :class="item.onlinelzv2 ? 'rounded-full bg-green-100 px-3 py-1 text-xs text-green-700' : 'rounded-full bg-red-100 px-3 py-1 text-xs text-red-700'"
                  >
                    {{ item.onlinelzv2 ? "Online" : "Offline" }}
                  </span>
                </td>

                <td class="px-6 py-5">
                  <div class="flex flex-wrap justify-center gap-2" v-if="$store.state.user.admin">
                    <router-link :to="`/${route}/form/${item._id}`" class="rounded-lg bg-blue-500 px-4 py-2 text-sm text-white transition hover:bg-blue-600"> Editar </router-link>

                    <button @click="modalTransferir(item)" type="button" class="rounded-lg bg-blue-500 px-4 py-2 text-sm text-white transition hover:bg-blue-600">Transferir</button>

                    <button
                      v-if="item.onlinelzv2"
                      @click="marcarOffline(item)"
                      type="button"
                      class="rounded-lg bg-blue-500 px-4 py-2 text-sm text-white transition hover:bg-blue-600"
                    >
                      Marcar offline
                    </button>

                    <button
                      v-if="item.ativo"
                      @click="desativarOperador(item)"
                      type="button"
                      :style="{ backgroundColor: mixPrimaryColor('#b91c1c', 0.45), color: '#fff' }"
                      class="rounded-lg px-4 py-2 text-sm text-white transition"
                    >
                      Desativar
                    </button>

                    <button
                      v-else
                      @click="ativarOperador(item._id)"
                      type="button"
                      :style="getPrimaryButtonStyle()"
                      class="rounded-lg px-4 py-2 text-sm text-white transition"
                    >
                      Ativar
                    </button>

                    <router-link :to="`/${route}/avaliacoes/${item._id}`" class="rounded-lg bg-gray-200 px-4 py-2 text-sm text-gray-700 transition hover:bg-gray-300"> Avaliações </router-link>

                    <button @click="remove(item._id)" type="button" class="rounded-lg bg-red-700 px-4 py-2 text-sm text-white transition hover:bg-red-800"> Excluir </button>
                  </div>
                </td>
              </tr>

              <tr v-if="operadoresPaginados.length === 0">
                <td colspan="6" class="px-6 py-12 text-center text-sm text-gray-400">Nenhum operador encontrado com os filtros atuais.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <pagination v-model="page" :per-page="perPage" :records="total" @paginate="setPage" class="pagination" />

      <modal name="transferirConversas" height="auto" width="560" :adaptive="true" classes="rounded-3xl overflow-hidden" :styles="{ borderRadius: '24px', overflow: 'hidden', background: 'transparent' }">
        <div class="overflow-hidden rounded-3xl bg-white shadow-2xl">
          <div class="flex items-start justify-between gap-4 border-b border-gray-100 px-6 py-5">
            <div>
              <h2 class="text-lg font-semibold text-gray-900">Transferir conversas</h2>
              <p class="mt-1 text-sm text-gray-500">Escolha o operador que vai receber as conversas.</p>
            </div>

            <button
              type="button"
              class="inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:bg-slate-50"
              @click="$modal.hide('transferirConversas')"
              aria-label="Fechar"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div class="px-6 py-6">
            <label for="operador" class="block text-sm font-medium text-gray-700">Operador</label>

            <div class="relative group mt-1">
              <select
                v-model="transferir.para"
                id="operador"
                name="operador"
                class="h-11 w-full appearance-none rounded-xl border border-gray-200 bg-white px-4 pr-10 text-gray-700 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
              >
                <option v-for="(p, idx) in listAll" :key="idx" :value="p._id">
                  {{ p.nome }}
                </option>
              </select>

              <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            <div class="mt-6 flex justify-end">
              <button
                @click="transferirConversas()"
                type="button"
                class="inline-flex h-11 items-center justify-center rounded-xl bg-blue-500 px-6 text-sm font-medium text-white shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:bg-blue-600 hover:shadow-md"
              >
                Transferir
              </button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import colorMixin from '@/utils/colorMixin';

export default {
  mixins: [colorMixin],
  data() {
    return {
      moment: moment,
      transferir: {
        operador: null,
        para: null
      },
      // quando uma exclusão é bloqueada por conversas, guardamos o id aqui
      pendingDeleteId: null,
      desativados: false,
      listarDesativados: false,
      filtroBusca: "",
      filtroStatus: "",
      filtroCentro: "",
      page: 1,
      perPage: 25,
      busca: "",
      centroscustos: [],
      centrocusto: null,
      route: "operadores",
      list: [],
      listAll: [],
      total: 0,
      baixandoRelatorio: false
    };
  },
  computed: {
    operadoresPaginados() {
      return this.list.filter((item) => {
        if (!this.filtroStatus) return true;
        return this.filtroStatus === "online" ? item.onlinelzv2 : !item.onlinelzv2;
      });
    }
  },
  methods: {
    async baixarRelatorio() {
      if (this.baixandoRelatorio) return;

      this.baixandoRelatorio = true;
      try {
        const response = await this.$http.get('/v1/operador/download/operadores', { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `relatorio-operadores-${this.moment().format('YYYY-MM-DD')}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.$vToastify.success('Relatório baixado com sucesso');
      } catch (error) {
        console.error(error);
        this.$vToastify.error('Erro ao baixar o relatório de operadores');
      } finally {
        this.baixandoRelatorio = false;
      }
    },
    irParaMensagensProibidas() {
      this.$router.push({ path: `/${this.route}/msgproibida` });
    },
    irParaNumerosProibidos() {
      this.$router.push({ path: `/${this.route}/numerosproibido` });
    },
    getInitials(nome) {
      if (!nome) return "--";
      return nome.slice(0, 2).toUpperCase();
    },
    aplicarFiltros() {
      this.busca = this.filtroBusca;
      this.centrocusto = this.filtroCentro || null;
      this.desativados = this.listarDesativados;
      this.setPage(1);
    },
    selecionarListagem(desativados) {
      this.listarDesativados = desativados;
      this.aplicarFiltros();
    },
    limparFiltros() {
      this.filtroBusca = "";
      this.filtroStatus = "";
      this.filtroCentro = this.$store.state.user.centrocusto || "";
      this.listarDesativados = false;
      this.busca = "";
      this.centrocusto = this.$store.state.user.centrocusto || null;
      this.desativados = false;
      this.setPage(1);
    },
    async setPage(page) {
      this.page = page;
      const skip = (page - 1) * this.perPage;
      const limit = this.perPage;

      const operadoresReq = await this.$http.post(`/v1/operador/list`, {
        busca: this.busca,
        centrocusto: this.centrocusto,
        desativados: this.desativados,
        limit,
        skip
      });

      const respAll = await this.$http.post(`/v1/operador/list`, {
        all: true,
        centrocusto: this.centrocusto
      });

      this.listAll = respAll.data.data;
      this.list = operadoresReq.data.data;
      this.total = operadoresReq.data.info.total;
    },

    async start() {
      await this.setPage(this.page);
    },

    async modalTransferir(operador) {
      const { _id, centrocusto } = operador;

      this.centrocusto = centrocusto;
      this.transferir.operador = _id;
      this.$modal.show("transferirConversas");
    },

    async transferirConversas() {
      if (!this.transferir.para) return this.$vToastify.error("Selecione o operador");
      if (!this.transferir.operador) return this.$vToastify.error("Selecione o operador");

      const resp = await this.$http.post(`/v1/operador/transferir`, {
        _id: this.transferir.operador,
        para: this.transferir.para,
        centrocusto: this.centrocusto
      });

      if (!resp.data.success) {
        this.$vToastify.error(resp.data.err);
        return;
      }

      this.$modal.hide("transferirConversas");
      this.$vToastify.success("Atualizado com sucesso");
      this.start();

      if (this.pendingDeleteId) {
        const idToDelete = this.pendingDeleteId;
        this.pendingDeleteId = null;
   
        setTimeout(() => this.remove(idToDelete), 500);
      }
    },

    async marcarOffline(operador) {
      if (!confirm(`Marcar ${operador.nome} como offline?`)) return;

      const resp = await this.$http.put(`/v1/operador`, {
        _id: operador._id,
        onlinelzv2: false
      });

      if (!resp.data.success) {
        this.$vToastify.error(resp.data.err);
        return;
      }

      this.$vToastify.success("Operador marcado como offline");
      this.start();
    },

    async ativarOperador(id) {
      if (confirm("Ativar operador?")) {
        const response = await this.$http.put(`/v1/operador`, {
          _id: id,
          ativarOperador: true
        });

        if (!response.data.success) {
          this.$vToastify.error(response.data.err);
          return;
        }

        this.$vToastify.success("Ativado com sucesso");
        this.start();
      }
    },

    async desativarOperador(operador) {
      if (!operador || !operador._id) return this.$vToastify.error("Operador inválido");

      if (confirm(`Desativar ${operador.nome}? Esse operador não poderá mais acessar a plataforma.`)) {
        const response = await this.$http.put(`/v1/operador`, {
          _id: operador._id,
          ativo: false,
          onlinelzv2: false,
          dataDesativado: this.moment().toDate()
        });

        if (!response.data.success) {
          this.$vToastify.error(response.data.err);
          return;
        }

        this.$vToastify.success("Operador desativado");
        this.start();
      }
    },

    async remove(operador) {
      const id = operador && operador._id ? operador._id : operador;
      if (!id) return this.$vToastify.error("ID do operador inválido");

      if (confirm("Tem certeza que deseja excluir esse operador?")) {
        const resp = await this.$http.delete(`/v1/operador/${id}`);
        if (!resp.data || !resp.data.success) {
          const err = (resp && resp.data && resp.data.err) || 'Erro ao remover operador';
          // Se o erro for sobre conversas ativas, abrir modal de transferência
          if (typeof err === 'string' && err.toLowerCase().includes('transfira as conversas')) {
            this.pendingDeleteId = id;
            this.transferir.operador = id;
            // limpar seleção anterior
            this.transferir.para = null;
            this.$modal.show('transferirConversas');
            this.$vToastify.info('Existem conversas ativas. Selecione outro operador para transferir as conversas antes de excluir.');
            return;
          }

          this.$vToastify.error(err);
          return;
        }
        this.$vToastify.success("Operador removido");
        this.start();
      }
    }
  },
  async beforeMount() {
    const centroscustoReq = await this.$http.post(`/v1/centrocusto/list`, { all: true });
    this.centroscustos = centroscustoReq.data.data;

    if (this.$store.state.user.centrocusto) {
      this.centrocusto = this.$store.state.user.centrocusto;
      this.filtroCentro = this.$store.state.user.centrocusto;
    }
    this.start();
  }
};
</script>

<style scoped>
:deep(.heroicon-ui) {
  fill: currentColor !important;
}

#centrocusto {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none !important;
}

#status-select,
#operador {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none !important;
}

#centrocusto::-ms-expand,
#status-select::-ms-expand,
#operador::-ms-expand {
  display: none;
}

.select-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  pointer-events: none;
  color: #9ca3af;
  transform: translateY(-50%);
  transition: transform 0.2s ease, color 0.2s ease;
}

.group:focus-within .select-icon {
  color: #6366f1;
  transform: translateY(-50%) rotate(180deg);
}

.card-access-arrow {
  display: inline-block;
  transform-origin: center;
  transform: rotate(0deg);
  transition: transform 0.22s ease-out;
  will-change: transform;
}

.card-access:hover .card-access-arrow {
  transform: rotate(42deg);
}
</style>
